var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap p-b-12" }, [
      _c(
        "div",
        {
          staticClass: "m-8 bg-FF b-r-8 flex col-center p-16",
          staticStyle: { width: "47.6%" },
        },
        [
          _vm._m(0),
          _c("div", [
            _c("div", { staticClass: "font-40 font-weight-700 m-b-16" }, [
              _vm._v(_vm._s(_vm.statisticsData?.contractInfo)),
              _c("span", { staticClass: "font-20" }, [_vm._v(" 万元")]),
            ]),
            _c("div", { staticClass: "font-24" }, [_vm._v("新签合同")]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "m-8 bg-FF b-r-8 flex col-center p-16",
          staticStyle: { width: "47.6%" },
        },
        [
          _vm._m(1),
          _c("div", [
            _c("div", { staticClass: "font-40 font-weight-700 m-b-16" }, [
              _vm._v(_vm._s(_vm.statisticsData?.invoiceInfo)),
              _c("span", { staticClass: "font-20" }, [_vm._v(" 万元")]),
            ]),
            _c("div", { staticClass: "font-24" }, [_vm._v("已开发票")]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "m-8 bg-FF b-r-8 flex col-center p-16",
          staticStyle: { width: "47.6%" },
        },
        [
          _vm._m(2),
          _c("div", [
            _c("div", { staticClass: "font-40 font-weight-700 m-b-16" }, [
              _vm._v(_vm._s(_vm.statisticsData?.debtInfo)),
              _c("span", { staticClass: "font-20" }, [_vm._v(" 万元")]),
            ]),
            _c("div", { staticClass: "font-24" }, [_vm._v("累计应收欠款")]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "m-8 bg-FF b-r-8 flex col-center p-16",
          staticStyle: { width: "47.6%" },
        },
        [
          _vm._m(3),
          _c("div", [
            _c("div", { staticClass: "font-40 font-weight-700 m-b-16" }, [
              _vm._v(_vm._s(_vm.statisticsData?.invoiceNotReceive)),
              _c("span", { staticClass: "font-20" }, [_vm._v(" 万元")]),
            ]),
            _c("div", { staticClass: "font-24" }, [_vm._v("已开票未回款")]),
          ]),
        ]
      ),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center m-b-20" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("前五业务合同分析"),
          ]),
        ],
        1
      ),
      _c("div", {
        ref: "htfxPie",
        staticStyle: { width: "90vw", height: "280px" },
        attrs: { id: "htfxPie" },
      }),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center m-b-20" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("欠款统计"),
          ]),
        ],
        1
      ),
      _c("div", {
        ref: "qktjBar",
        staticStyle: { width: "90vw", height: "220px" },
        attrs: { id: "qktjBar" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-80 h-80 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "item.label",
          src: require("@/assets/icon/employeeKanban/geshui.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-80 h-80 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "公积金扣款",
          src: require("@/assets/icon/employeeKanban/gongjijin.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-80 h-80 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "社保扣款",
          src: require("@/assets/icon/employeeKanban/shebao.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-80 h-80 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "其他扣款",
          src: require("@/assets/icon/employeeKanban/qita.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }